export const trojaner = `
# Trojaner (Dieses Fachthema wird demnächst hinzugefügt)
`;